(function () {
  var cfg = (window.ShopifyFormsCustom && window.ShopifyFormsCustom.config) || {};
  if (cfg.enabled !== true) return;

  var DEBUG = false;

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, arguments); } catch (e) {}
  }

  function toNumber(v, fallback) {
    var n = Number(String(v || "").replace(",", ".").trim());
    return Number.isFinite(n) ? n : fallback;
  }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  var maxWidthPx = clamp(toNumber(cfg.maxWidthPx, 640), 280, 900);

  var imgPct = clamp(toNumber(cfg.imgPct, 33), 0, 100);
  var contentPct = clamp(toNumber(cfg.contentPct, 67), 0, 100);
  if (imgPct === 0 && contentPct === 0) { imgPct = 33; contentPct = 67; }

  var containerBg = (cfg.containerBg || "#FFFFFF");

  var containerRadius = clamp(toNumber(cfg.containerRadius, 10), 0, 100) + "px";
  var inputRadius = clamp(toNumber(cfg.inputRadius, 5), 0, 100) + "px";
  var buttonRadius = clamp(toNumber(cfg.buttonRadius, 5), 0, 100) + "px";

  var targetId = cfg.targetId; // optional

  function matchesTarget(embedEl) {
    if (!targetId) return true;
    return embedEl && embedEl.id === targetId;
  }

  function buildShadowCSS() {
    return `
      ._grid_1q1d2_148 {
        grid-template-columns: ${imgPct}% ${contentPct}% !important;
        max-width: ${maxWidthPx}px !important;
      }
      ._formContainer_1q1d2_30 {
        max-width: ${maxWidthPx}px !important;
      }
    `;
  }

  function applyToEmbed(embedEl) {
    if (!embedEl || !matchesTarget(embedEl)) return;

    // Variables sur le host (Shadow DOM friendly)
    try {
      embedEl.style.setProperty("--container-background-color", containerBg, "important");
      embedEl.style.setProperty("--container-border-radius", containerRadius, "important");
      embedEl.style.setProperty("--form-field-border-radius", inputRadius, "important");
      embedEl.style.setProperty("--button-border-radius", buttonRadius, "important");
    } catch (e) {}

    // Injection Shadow (grid / max-width)
    var shadow = embedEl.shadowRoot;
    if (!shadow) return;

    var styleId = "sf-custom-shadow-style";
    var styleEl = shadow.getElementById(styleId);
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = styleId;
      shadow.appendChild(styleEl);
    }

    var css = buildShadowCSS();
    if (styleEl.textContent !== css) styleEl.textContent = css;
  }

  function applyAll() {
    var embeds = document.querySelectorAll("shopify-forms-embed");
    embeds.forEach(applyToEmbed);
    if (!embeds.length) log("No shopify-forms-embed yet");
  }

  function run() {
    applyAll();

    // L’embed / la popup peuvent arriver plus tard
    var mo = new MutationObserver(applyAll);
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Re-apply pendant ~10s pour couvrir les rerenders
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      applyAll();
      if (tries >= 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
